import { useQuery } from '@tanstack/react-query'
import { API_ENDPOINT } from '~/api/utils'

export interface OAuthClientInfo {
  client_id: string
  name: string
  scopes: string[]
}

const SCOPE_LABELS: Record<string, string> = {
  'applications:read': 'Lire les candidatures',
  'applications:edit': 'Modifier les candidatures',
  'companies:read': 'Lire les entreprises',
  'companies:edit': 'Modifier les entreprises',
  'contacts:read': 'Lire les contacts',
  'contacts:edit': 'Modifier les contacts',
  'applicants:read': 'Lire les candidats',
  'applicants:edit': 'Modifier les candidats',
  'actions:read': 'Lire les actions',
  'actions:edit': 'Modifier les actions',
  'orders:read': 'Lire les commandes',
  'orders:edit': 'Modifier les commandes',
  'offers:read': 'Lire les offres',
  'aliases:edit':
    "Modifier les détails de la publication d'une offre sur un jobboard",
  'listings:edit':
    'Lire et modifier les correspondances de référentiels externes',
  'taxonomies:read': 'Lire les référentiels',
  'taxonomies:edit': 'Modifier les référentiels',
  profile: "Voir les informations de l'utilisateur connecté",
  admin: 'Administrer les taxonomies, utilisateurs, agences et séquences'
}

export const getScopeLabel = (scope: string): string =>
  SCOPE_LABELS[scope] ?? scope

const fetchClientInfo = async (clientId: string): Promise<OAuthClientInfo> => {
  const response = await fetch(
    `${API_ENDPOINT}/oauth/client-info?client_id=${encodeURIComponent(clientId)}`
  )
  if (!response.ok) {
    throw new Error('Client OAuth introuvable')
  }
  return response.json()
}

export const useOAuthClientInfo = (clientId: string) =>
  useQuery({
    queryKey: ['oauth', 'client-info', clientId],
    queryFn: () => fetchClientInfo(clientId),
    enabled: !!clientId
  })
